import React, { useContext, useEffect, useState } from "react";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { ListDetailsContext } from "../../contexts/ListDetailsContext";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExAvailabilityComment({
  comment,
  expert_id,
  setAvailabilityComment,
}) {
  const { tableData, setTableData } = useContext(ListDetailsContext);
  const [value, setValue] = useState("");
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showFromValue, setShowFromValue] = useState(false);
  const { API_URL } = useContext(UrlContext);

  useEffect(() => {
    if (comment === "None" || comment === null) return;
    setValue(comment);
  }, [comment]);

  const changeComment = (newValue) => {
    setReturnError(false);
    setLoading(true);
    const url = `${API_URL}change-availability-comment`;
    const data = {
      expert_id,
      availComment: newValue,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setShowFromValue(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          setTableData(
            tableData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.Available_comment = newValue;
              }
              return item;
            })
          );
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        console.log(err);
      });
  };

  return (
    <>
      <div className="prjdetails-available-comment">
        <textarea
          placeholder="Availability comment"
          value={showFromValue ? value : comment}
          onChange={(e) => {
            setValue(e.target.value);
            setShowFromValue(true);
          }}
          onBlur={(e) => {
            changeComment(e.target.value);
            setAvailabilityComment(e.target.value);
          }}
        />
        {loading && (
          <img
            className="return-msg-icon"
            style={{ top: "59px", right: "0" }}
            src={LoadingIcon}
            alt="loading"
            title="Loading..."
          />
        )}
        {returnSuccess && (
          <img
            className="return-msg-icon"
            style={{ top: "59px", right: "0" }}
            src={successIcon}
            alt="success"
            title="Success"
          />
        )}
        {returnError && (
          <img
            className="return-msg-icon"
            style={{ top: "59px", right: "0" }}
            src={errorIcon}
            alt="error"
            title="Error! Please reload"
          />
        )}
      </div>
    </>
  );
}
